export enum FormType {
    ACTIVITY = 'ACTIVITY',
    LEAVE = 'LEAVE',
    PERSONAL_GOAL = 'PERSONAL_GOAL',
    HEALTH_AND_SAFETY_TRAINING = 'HEALTH_AND_SAFETY_TRAINING',
    CONSIDERATION = 'CONSIDERATION',
    BEHAVIOURAL = 'BEHAVIOURAL',
}
